import { isFeatureUnlocked } from "@/common/featureLock.js";

export let LABELS = {
  stability: "Stability",
  pulse: "Pulse AI",
  scribe: "Scribe AI",
  events: "Events",
  hotspots: "Hotspots AI",
  cr_risk: "Risk",
  cr_risks: "Risks",
  cr_risk_rating: "Risk Rating",
  cr_risk_ratings: "Risk Ratings",
  cr_incidents: "Verified Events",
  cr_updates: "Analysis",
  search: "Search",
};

export function setLabels() {
  // due to feature locking we need to dynamically set these constants
  // to make sure the new label names don't get released before we want
  if (!isFeatureUnlocked("cr_risks")) {
    LABELS.pulse = "Pulse";
    LABELS.scribe = "Scribe";
    LABELS.events = "Events";
    LABELS.hotspots = "Hotspots";
    LABELS.cr_incidents = "Incidents";
  }

  if (!isFeatureUnlocked("livesearch-filter-events-v2")) {
    LABELS.events = "Events AI";
  }
}
